"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChariotResource_1 = require("../resources/models/ChariotResource");
var ApiChariotResource_1 = require("../resources/api/ApiChariotResource");
var Errors_1 = require("./Errors");
var ResourceCache = /** @class */ (function () {
    function ResourceCache() {
        this.getCache = new Map();
        this.listCache = new Map();
        this.findCache = new Map();
        this.pointers = new Map();
    }
    ResourceCache.prototype.get = function (method, key) {
        switch (method) {
            case "get":
                return this.getCache.get(key);
            case "list":
                return this.listCache.get(key);
            case "find":
                return this.findCache.get(key);
        }
    };
    ResourceCache.prototype.set = function (method, key, value) {
        switch (method) {
            case "get":
                if (Array.isArray(value))
                    throw new Errors_1.ValidationError("Attempted to store list data in get method cache.");
                return this.getCache.set(key, value);
            case "list": {
                if (!Array.isArray(value))
                    throw new Errors_1.ValidationError("Attempted to store non-list data in list method cache.");
                var valueCopied = __spreadArray([], value, true);
                for (var index = 0; index < valueCopied.length; index += 1) {
                    var item = valueCopied[index];
                    if (item._.id) {
                        this.updatePointers(item._.id, "list", key);
                        var itemInCache = this.get("get", item._.id);
                        if (itemInCache && !Array.isArray(itemInCache)) {
                            valueCopied[index] = itemInCache;
                            continue;
                        }
                        this.set("get", item._.id, item);
                    }
                }
                return this.listCache.set(key, valueCopied);
            }
            case "find": {
                if (Array.isArray(value))
                    throw new Errors_1.ValidationError("Attempted to store list data in find method cache.");
                if (value._.id) {
                    this.updatePointers(value._.id, "find", key);
                    var valueInCache = this.get("get", value._.id);
                    if (valueInCache && !Array.isArray(valueInCache)) {
                        return this.findCache.set(key, valueInCache);
                    }
                    this.set("get", value._.id, value);
                }
                return this.findCache.set(key, value);
            }
        }
        return this.getCache;
    };
    ResourceCache.prototype.has = function (method, key) {
        switch (method) {
            case "get":
                return this.getCache.has(key);
            case "list":
                return this.listCache.has(key);
            case "find":
                return this.findCache.has(key);
        }
        return false;
    };
    ResourceCache.prototype.updatePointers = function (id, method, key) {
        var pointers = this.pointers.get(id) || [];
        pointers.push([method, key]);
        this.pointers.set(id, pointers);
    };
    ResourceCache.prototype.removeItem = function (item) {
        if (item._.id) {
            if (this.has("get", item._.id)) {
                this.getCache.delete(item._.id);
                var pointers = this.pointers.get(item._.id) || [];
                for (var _i = 0, pointers_1 = pointers; _i < pointers_1.length; _i++) {
                    var _a = pointers_1[_i], method = _a[0], key = _a[1];
                    switch (method) {
                        case "list": {
                            var value = this.listCache.get(key);
                            if (value) {
                                this.listCache.set(key, value.filter(function (_a) {
                                    var _ = _a._;
                                    return _.id !== item._.id;
                                }));
                            }
                            break;
                        }
                        case "find": {
                            this.findCache.delete(key);
                            break;
                        }
                    }
                }
            }
        }
    };
    ResourceCache.prototype.addItem = function (item) {
        if (item._.id) {
            this.getCache.set(item._.id, item);
            this.invalidateCache();
        }
    };
    ResourceCache.prototype.invalidateCache = function () {
        this.listCache = new Map();
        this.findCache = new Map();
    };
    return ResourceCache;
}());
exports.default = ResourceCache;
